<div id="main">
  <div class="modal-header">
    <h4 class="modal-title">{{projectName}} - {{"EVENTDYN_SUBSCRIPTION" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" id="close" mat-dialog-close>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body formModal">
    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step>
        <ng-template matStepLabel>{{'CHECK_SAVE' | translate}}</ng-template>
          <div>
            <button class="btn btn-info" mat-button [innerHTML]="'CANCEL' | translate" mat-dialog-close>
              Cancel
            </button>
            <button type="button" class="btn btn-warning" (click)="subscribeProjectToEventdyn(projectId)">
              <app-progressbar *ngIf="showSpinner"></app-progressbar>
              {{'SAVE'|translate}}
            </button>
          </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
